
import { subDays, subHours } from 'date-fns';
import { Box, Container, Unstable_Grid2 as Grid } from '@mui/material';


import { OverviewLatestCustomers } from 'src/sections/overview/overview-latest-customers';
import { OverviewLatestCompletedRides } from 'src/sections/overview/overview-latest-products';

import { OverviewTotalCustomers } from 'src/sections/overview/overview-total-customers';
import { OverviewTotalProfit } from 'src/sections/overview/overview-total-profit';
import { useEffect, useState } from 'react';
import dashboardService from 'src/services/dashboardService';
import authService from 'src/services/authService';
import { OverviewTotalRider } from 'src/sections/overview/overview-total-rider';
import { OverviewTotalVehicle } from 'src/sections/overview/overview-total-vehicle';
import { DashbaordLayout } from 'src/layouts/dashboard/layout';
import OverviewSales from 'src/sections/overview/overview-sales';


const now = new Date();

export const Dashbaord = () => {

  const [latestCustomers, setLatestCustomers] = useState([]);
  const [latestRide, setlatestRide] = useState([]);
  const [profile, setprofile] = useState([]);
  const [totalRideAmount, setTotalRideAmount] = useState([]);
  const [totalRiders, setTotalRiders] = useState([]);
  const [totalCustomers, setTotalCustomers] = useState([]);
  const [monthlySales, setMonthSales] = useState([]);
  useEffect(() => {
    getUserDetail();
  }, [])


  const getUserDetail = async () => {
    await authService.getUserDetail().then((res) => {
      if (res.status == 200) {
        getDashBoardDetail();
        getMonthlySales();
      } else {

      }
    }
    );
  }
  const getMonthlySales = async () => {
    await dashboardService.getMonthlySales()
      .then((res) => {
      
        if (res.status == 200) {
          setMonthSales(res.data);
        }
      })
  }

  const getDashBoardDetail = async () => {
    await dashboardService.dashboard().then((res) => {
      
      if (res.status == 200) {
        setLatestCustomers(res.data.latestCustomers);
        setlatestRide(res.data.latestRides);
        setprofile(res.data.profit);
        setTotalRideAmount(res.data.totalRideAmount);
        setTotalRiders(res.data.totalRiders);
        setTotalCustomers(res.data.totalCustomers);
       
      }

    });
  }
  return (
    <>

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          py: 8
        }}
      >
        <Container maxWidth="xl">
          <Grid
            container
            spacing={3}
          >

            <Grid
              xs={12}
              sm={6}
              lg={3}
            >
              <OverviewTotalCustomers
                // difference={16}
                positive={false}
                sx={{ height: '100%' }}
                value={totalCustomers.toString()}
              />

            </Grid>
            <Grid
              xs={12}
              sm={6}
              lg={3}
            >
              <OverviewTotalRider
                // difference={16}
                positive={false}
                sx={{ height: '100%' }}
                value={totalRiders.toString()}
              />

            </Grid>
            <Grid
              xs={12}
              sm={6}
              lg={3}
            >
              <OverviewTotalVehicle
                // difference={16}
                positive={false}
                sx={{ height: '100%' }}
                value={totalRiders.toString()}
              />

            </Grid>

            <Grid
              xs={12}
              sm={6}
              lg={3}
            >
              <OverviewTotalProfit
                sx={{ height: '100%' }}
                value={totalRideAmount.toString()}
              />
            </Grid>
            <Grid
              xs={12}
              lg={8}
            >
               <OverviewLatestCustomers
                customers={latestCustomers
                }
                sx={{ height: '100%' }}
              />
              {/* <OverviewSales
              chartSeries={
                monthlySales
            }
              sx={{ height: '100%' }}
            /> */}
            </Grid>

            <Grid
              xs={12}
              md={6}
              lg={4}
            >
              <OverviewLatestCompletedRides
                rides={latestRide}
                sx={{ height: '100%' }}
              />
            </Grid>
            {/* <Grid
              xs={12}
              md={12}
              lg={8}
            >
             
            </Grid> */}
          </Grid>
        </Container>
      </Box>
    </>
  );
};

// Dashbaord.getLayout = (page) => (
//   <DashbaordLayout>
//     {page}
//   </DashbaordLayout>
// );

export default Dashbaord;
